/**
 * Created by mateimisarca on 2019-06-07
 */

import P403 from './403-page';

export default P403;
